"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _decorators = require("../../decorators");
var _styles = require("./styles");
var _excluded = ["icons", "name"]; //helpers
//styled-components
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var AbstractIconComponent = (0, _decorators.styleable)(function (_ref) {
  var icons = _ref.icons,
    name = _ref.name,
    forwardedProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styles.Icon, _extends({}, forwardedProps, {
    className: "icon ".concat(name),
    dangerouslySetInnerHTML: {
      __html: icons[name] || icons["default"]
    }
  }));
});
AbstractIconComponent.defaultProps = {
  name: 'default',
  shouldInheritTextColor: true,
  size: 24,
  valign: 'middle'
};
AbstractIconComponent.propTypes = {
  icons: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  name: _propTypes["default"].string.isRequired,
  shouldInheritTextColor: _propTypes["default"].bool,
  size: _propTypes["default"].number
};
var _default = exports["default"] = AbstractIconComponent;
//# sourceMappingURL=index.js.map